import React, { memo, useState, useMemo } from 'react';
import map from 'lodash/map';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import DarkenBackground from '../../../shared/components/DarkenBackground/DarkenBackground';
import WhiteLogo from '../../../shared/images/logos/denwa_uc_white.png';
import SideBarOption from '../SideBarOption/SideBarOption';
import homeRoutes from '../../routes/homeRoutes';
import styles from './sideBar.module.scss';

export default memo(function SideBar(props) {
    const [showTitle, setShowTitle] = useState(false);

    const forbiddenRoutesIfNotOnNano = ['QUICK_SETUP'];

    const routes = useMemo(() =>
        (props.isNano && !props.hasSetup
            ? homeRoutes.routes
            : filter(homeRoutes.routes, route => !includes(forbiddenRoutesIfNotOnNano, route.title)))
    );

    const navigate = route => props.history.push(route.path);

    const navigateToLegacySite = () => {
        const legacySiteAddress = process.env.NODE_ENV === 'development'
            ? 'http://192.168.144.106/admin/home.php'
            : `${window.location.protocol}//${window.location.hostname}/admin/home.php`;

        window.open(legacySiteAddress, '_blank');
    };

    const logOut = () => props.logOut(props.isAdmin, props.history);

    const handleMouseEnter = () => setShowTitle(true);

    const handleMouseLeave = () => setShowTitle(false);

    return (
        <>
            <DarkenBackground isDarkened={showTitle} />
            <div className={styles.menu} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                <div className={styles.logo}>
                    <img alt="DenwaLogo" className={styles.denwa} height="40" src={WhiteLogo} width="40" />
                    <div className={styles.brand}>
                        <span>Denwa UC</span>
                        <span>Comunification</span>
                    </div>
                </div>
                <ul>
                    {map(routes, (route, index) => (
                        (typeof route.permission === 'undefined' || parseInt(props.permissions[route.permission.index]) >= route.permission.value) ?
                        <li key={index}>
                            <SideBarOption
                                route={route}
                                expandable={route.expandable}
                                icon={route.icon}
                                location={props.location.pathname}
                                path={route.path}
                                showTitle={showTitle}
                                onClick={navigate.bind(this, route)}
                                title={route.title}
                            />
                        </li> :
                        null
                    ))}
                </ul>
                <ul>
                    <li>
                        <SideBarOption
                            icon="./icons/external_site.svg"
                            location={null}
                            onClick={navigateToLegacySite}
                            showTitle={showTitle}
                            title="legacy_site"
                        />
                    </li>
                    <li>
                        <SideBarOption
                            icon="./icons/logout.svg"
                            location={null}
                            onClick={logOut}
                            showTitle={showTitle}
                            title="log_out"
                        />
                    </li>
                </ul>
            </div>
        </>
    );
});
